import { titleize } from 'inflected';
import { MergeSourceData } from '../model';
import { getMergeDataset } from '../utilities';

export const MergeSource = (options?: Partial<MergeSourceData>): PropertyDecorator => {
    return (target: any, propertyKey: string | symbol): void => {

        const meta = getMergeDataset(target);

        const source = {
            name: propertyKey,
            displayName: titleize(propertyKey as string),

            ...options
        } as MergeSourceData;

        meta.sources.push(source)

    };
};